import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { studioSignInPage } from './SignInPage';

/**
 * Overrides the app's default (guest-only) sign-in page with the Studio sign-in page
 * that offers GitLab OAuth (Auth B). Registered as an `app`-plugin frontend module.
 */
export const authModule = createFrontendModule({
  pluginId: 'app',
  extensions: [studioSignInPage],
});
